import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CommonService } from '../../core/services/v2/common.service';
import { UserService } from '../../core/services/v2/user.service';
import { UtilsService } from '../../core/services/v2/utils.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-plan-coverage',
  templateUrl: './plan-coverage.component.html',
  styleUrls: ['./plan-coverage.component.scss']
})
export class PlanCoverageComponent implements OnInit, AfterViewInit {
  insurancePlans: any;
  filteredInsurancePlans: Observable<any>;
  insurancePlanCtrl = new FormControl();
  selectedInsurances: any = [];
  employerInsurancePlans: any=[];
  employerId: number;
  constructor(private commonService: CommonService, private utils: UtilsService,
    private loaderService: WindowLoaderService, private _userService:UserService) { }

  ngOnInit() {
    this.loadInsurancePlans();
  }
  ngAfterViewInit() {
    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.employerId = userDetails.employerId ? userDetails.employerId : 0;
        if (this.employerId > 0) {
          this.getEmployerInsurances();
        }       
      },
      (error) => {
        console.error(error);
      },
      () => {
        //   this.loaderService.hide();
      }
    );

  }
  loadInsurancePlans() {
      this.commonService.getInsurances().subscribe((res) => {
        this.insurancePlans = res.insurances;
        this.filteredInsurancePlans = this.insurancePlanCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '')),
        );
      });
  }
  getEmployerInsurances() {
    this.commonService.getEmployerInsurancePlans(this.employerId).subscribe((res) => {
      if (res && res.length > 0) {
        this.employerInsurancePlans = [...res];
        if (this.employerInsurancePlans.length > 0) {
          this.employerInsurancePlans.forEach(x => {
            this.selectedInsurances.push({ "planname": x.name, "planid": x.id });
            })
        }
      }
    
    });
  }
  removeInsurance(event: any) {
    this.selectedInsurances.splice(this.selectedInsurances.indexOf(event), 1);
    this.SaveInsurancePlan();
    
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.insurancePlans.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  addInsurance() {
    if ((this.insurancePlanCtrl.value!=null) && !this.selectedInsurances.find(x => x.planname == this.insurancePlanCtrl.value)) {
      this.selectedInsurances.push({ "planname": this.insurancePlanCtrl.value, "planid": this.insurancePlans.find(x => x.name == this.insurancePlanCtrl.value).id });
      this.SaveInsurancePlan();
      this.insurancePlanCtrl.setValue("");
    }
    
  }

  SaveInsurancePlan() {
    let insurancePlanIds = [];
    this.selectedInsurances.forEach(x => {
      insurancePlanIds.push(x.planid);
    })
    const req = {
      employerId: this.employerId,
      employerInsurancePlanIds: insurancePlanIds,
    };
    this.loaderService.show();
    this.commonService.updateEmployerInsurances(req).subscribe(
      (res) => {
        if (res.isSuccess) {
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
      
    );
  }

 
}
